<template>
  <div class="layout-list">
    <h1 class="title">
      {{ title }}
      <a v-if="collapseStatue" href="#" class="btn-expand-all" @click.prevent="collapseAll">
        完全收合<i class="material-icons">
          expand_more
        </i>
      </a>
      <a v-else href="#" class="btn-expand-all" @click.prevent="expandAll">
        完全展開<i class="material-icons">
          expand_less
        </i>
      </a>
    </h1>
    <div class="accordion-block">
      <Accordion v-for="n in 4" ref="accordion" :key="n" :active="n===1" title="ㄅ">
        <slot>
          <ul class="block-list">
            <li>
              <RouterLink :to="{ name: type+'ById', params: { locale: $i18n.localePath(), id: '123' }}">
                伯尼爾, 尼可拉斯
              </RouterLink>
            </li>
            <li>伯德, 威廉</li>
            <li>博伊托, 阿里格 博伊托, 阿里格 博伊托, 阿里格 博伊托, 阿里格</li>
            <li>博得斯基, 尼古拉斯</li>
            <li>巴克斯, 阿諾德</li>
            <li>巴哈, 卡爾·飛利浦·愛馬努埃爾</li>
            <li>巴拉基列夫, 米利 阿列克謝耶維奇</li>
            <li>巴格利, 愛德華 尤金</li>
            <li>巴濟尼, 安東尼歐</li>
            <li>巴爾夫, 麥可 威廉</li>
            <li>巴爾托克, 貝拉</li>
            <li>巴特沃斯, 喬治</li>
            <li>巴赫, 約翰·克里斯蒂安</li>
            <li>巴赫, 約翰.塞巴斯蒂安</li>
            <li>布克斯特胡德, 迪特里克</li>
            <li>布拉姆斯, 約翰尼斯</li>
          </ul>
        </slot>
      </Accordion>
    </div>
  </div>
</template>

<script>
import Accordion from '@/components/common/Accordion'

export default {
  name: 'Composer',
  components: {
    Accordion
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    listData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      collapseStatue: false
    }
  },
  methods: {
    collapseAll() {
      this.$refs.accordion.map((item) => {
        item.isActive = false
        this.collapseStatue = false
      })
    },
    expandAll() {
      this.$refs.accordion.map((item) => {
        item.isActive = true
        this.collapseStatue = true
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.layout-list {
  .title{
    position: relative;
    font-size: 24px;
    font-weight: 500;
    line-height: 1.6;
    color: $grey-50;
    margin: 0 0 16px;
  }
  .btn-expand-all{
    font-size: 20px;
    font-weight: 500;
    line-height: 1.6;
    text-decoration: none;
    color: $theme-red;
    position: absolute;
    top: 3px;
    right: 0;
    i{
      position: relative;
      width: 24px;
      height: 24px;
      vertical-align: middle;
      top: -2px;
      margin-left: 4px;
    }
  }
  .block-list{
    list-style: none;
    margin: 0;
    padding: 0 36px;
    transition: padding .3s ease-in-out;
    li{
      display: inline-block;
      width: 33.33%;
      float: left;
      font-size: 16px;
      font-weight: bold;
      color: $grey-7d;
      line-height: 1.6;
      overflow : hidden;
      text-overflow : ellipsis;
      white-space : nowrap;
      padding-right: 16px;
      a{
        text-decoration: none;
        color: $grey-7d;
      }
    }
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
  .accordion{
    &.active{
      .block-list{
        padding: 16px 36px;
        transition-timing-function: ease-out;
      }
    }
  }
}

@media only screen and (min-width: 1440px) {
  //as default
}

@media only screen and (max-width: 1439.98px) {
}

@media only screen and (max-width: 1023.98px) {
}

@media only screen and (max-width: 767.98px) {
  .layout-list{
    .block-list{
      li{
        width: 50%;
      }
    }
  }
}

@media only screen and (max-width: 480px) {
  .layout-list{
    .block-list{
      li{
        width: 100%;
      }
    }
  }
}

</style>
